<section fxFlex="100" fxLayout="column">
  <div class="catalog-page-content-wrapper" fxLayout="column">
    <app-page-content-wrapper [contentPadding]="commonProps.isDesktop ? '0px' : '0 20px'" class="catalog-page-content-wrapper__component">
      <ng-container *ngIf="isServer; else isClientSide">
        <div class="catalog-page-content-wrapper__component__cover"></div>
      </ng-container>
    </app-page-content-wrapper>
  </div>
</section>
<ng-template #isClientSide>
  <ng-container *ngTemplateOutlet="commonProps.isLoading ? catalogLoading : productListPage"> </ng-container>
</ng-template>

<ng-template #catalogLoading>
  <app-catalog-loading
    [isMobile]="commonProps.isMobile"
    [isTablet]="commonProps.isTablet"
    [isDesktop]="commonProps.isDesktop"
    [isLandScapeTablet]="commonProps.isLandScapeTablet"
  >
  </app-catalog-loading>
</ng-template>
<ng-template #productListPage>
  <app-catalog-products-list
    [searchQuery]="commonProps.searchQuery"
    [searchCorrection]="searchCorrection$ | async"
    [products]="commonProps.products"
    [totalCount]="commonProps.productsTotalCount"
    [recommendedProducts]="commonProps.recommendedProducts"
    [recommendedProductsType]="commonProps.recommendedProductsType"
    [seoContent]="seoContent$ | async"
    [storyblokSeoContent]="story$ | async"
    [isSearchPage]="isSearchPage"
    [isCustomPLPPage]="isCustomPLPPage"
    [queryParams]="commonProps.queryParams"
    [isMobileOrTablet]="commonProps.isMobile || commonProps.isTablet"
    [isDesktop]="commonProps.isDesktop"
    [isMobile]="commonProps.isMobile"
    [isZeroResult]="commonProps.isZeroResult"
    [hasFilters]="commonProps.hasFilters"
    [isExpired]="commonProps.isExpired"
    [isTablet]="commonProps.isTablet"
  >
  </app-catalog-products-list>
</ng-template>
